import { SET_FORM_INFOS } from 'root/src/client/logic/form/actionIds'

import {
	formStoreLenses,
} from 'root/src/client/logic/form/lenses'

const { setFieldInfos } = formStoreLenses

export const reducer = (state, { moduleKey, infos }) => setFieldInfos(
	moduleKey,
	infos,
	state,
)

export default {
	[SET_FORM_INFOS]: reducer,
}
